import {
	RENAME_CREATIVE,
	DUPLICATE_CREATIVE,
	DOWNLOAD_CREATIVE,
	DOWNLOAD_CREATIVE_SUMMARY,
	SELECT_NEW_VIDEO,
	UPLOAD_CLOSED_CAPTION,
	DELETE_CLOSED_CAPTION,
	CLASSIFY,
	PREDICTIVE_SCORING,
	DELETE_CREATIVE
} from "./EllipsisActions";

export const TRANSCODING_ELLIPSIS_ACTION_LIST = [
	[
		RENAME_CREATIVE,
	],
	[
		UPLOAD_CLOSED_CAPTION,
		DELETE_CLOSED_CAPTION,
	],
	[
		DELETE_CREATIVE,
	],
];

export const TRANSCODED_ELLIPSIS_ACTION_LIST = [
	[
		RENAME_CREATIVE,
		DUPLICATE_CREATIVE,
		DOWNLOAD_CREATIVE,
		DOWNLOAD_CREATIVE_SUMMARY,
	],
	[
		SELECT_NEW_VIDEO,
	],
	[
		UPLOAD_CLOSED_CAPTION,
		DELETE_CLOSED_CAPTION,
	],
	[
		CLASSIFY,
		PREDICTIVE_SCORING,
	],
	[
		DELETE_CREATIVE,
	],
];
